import { getPrivateApi } from "../lib/axiosConfig";
import { RemoveCamQueue } from "../types/camQueue.types";
import { GetStationsResponse, Station } from "../types/stations.types";
import { AppError } from "./classes";

const api = getPrivateApi();
const endpoint = "/stations";


export const getStations = async (): Promise<Station[]> => {

  try {
    const { data: response } = await api.get<GetStationsResponse>(`${endpoint}`);

    return response.content;

  } catch (error: any) {
    const errMsg = "Erro ao buscar postos!";

    console.error(errMsg, error?.response ?? error);
    
    const message = error?.response?.data?.message ?? errMsg;
    
    throw new AppError(message, error.status);
  };
}

export const getStationByCode = async (code: string): Promise<Station> => {

  try {
    const { data: response } = await api.get<Station>(`${endpoint}/code/${code}`);

    return response;

  } catch (error: any) {
    const errMsg = "Erro ao buscar posto!";

    console.error(errMsg, error?.response ?? error);
    
    const message = error?.response?.data?.message ?? errMsg;
    
    throw new AppError(message, error.status);
  };
}

export const getQueue = async (station: string, token?: string) => {
    try {
        const response = await api.get(`${endpoint}/queue?station=${station}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error: any) {
        console.error("Erro ao buscar fila: ", error);
        throw error;
    }
}

export const removeFromCamQueue = async (payload: RemoveCamQueue): Promise<void> => {

  try {
    await api.put(`${endpoint}/cam-queue/remove`,
        payload
    );
  } catch (error: any) {
    const errMsg = "Erro ao modificar status!";

    console.error(errMsg, error?.response ?? error);
    
    const message = error?.response?.data?.message ?? errMsg;
    
    throw new AppError(message, error.status);
  };
}

export const removeVehicleQueue = async (payload: any): Promise<void> => {

  try {
    await api.put(`${endpoint}/manual-queue/remove`,
        payload
    );
  } catch (error: any) {
    const errMsg = "Erro ao modificar status!";

    console.error(errMsg, error?.response ?? error);
    
    const message = error?.response?.data?.message ?? errMsg;
    
    throw new AppError(message, error.status);
  };
}

